import React from 'react';
import { DonutChart } from '@atlassian/viz-platform-charts/charts';
import { element, useElementProps } from '@atlassian/viz-platform-charts/core';
import type { DataType } from '../../../../common/types.tsx';

export const CustomLegend = element(
	() => {
		const { data } = useElementProps(DonutChart.elements.Legend);

		// Sort the data by value in ascending order, but keep "Other" at the end
		data.sort((a: DataType, b: DataType) => {
			if (a.label === 'Other') return 1;
			if (b.label === 'Other') return -1;
			return (a.value ?? 0) - (b.value ?? 0);
		});

		return <DonutChart.elements.Legend data={data} maxRows={10} />;
	},
	{ as: DonutChart.elements.Legend },
);
